/**
 * @flow
 */

import React from 'react';
import { Modal, Header, Button, Icon, Message } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import type { ModalDialog, Seminar } from '../../../type';

const MessageBlock = styled(Message)`
    background-color: transparent !important;
    border: 2px solid #ff4545;
    color: #ff4545 !important;
    font-weight: bold;
    box-shadow: none !important;
`;

type DeleteSeminarDialogProps = {
    seminar: Seminar,
} & ModalDialog;

const DeleteSeminarDialog = ({
    seminar,
    trigger,
    open,
    onClose,
    submitting,
    handleSubmit,
    error,
}: DeleteSeminarDialogProps) => (
    <Modal trigger={trigger} open={open} onClose={onClose} size="small" basic>
        <Header icon>
            <Icon name="remove" />
            <FormattedMessage
                id="pages.seminars.DeleteSeminarDialog.deleteSeminar"
                defaultMessage="Delete Seminar"
            />
        </Header>
        <Modal.Content>
            <FormattedMessage
                id="pages.seminars.DeleteSeminarDialog.confirmMessage"
                defaultMessage="Are you sure you want to delete this seminar?"
            >
                {message => <p>{message}</p>}
            </FormattedMessage>
            {error && (
                <MessageBlock error>
                    <Icon name="warning sign" />
                    {error}
                </MessageBlock>
            )}
        </Modal.Content>
        <Modal.Actions>
            <Button onClick={onClose} color="red" basic inverted>
                <Icon name="remove" />
                <FormattedMessage
                    id="pages.seminars.DeleteSeminarDialog.no"
                    defaultMessage="No"
                />
            </Button>
            <Button
                onClick={handleSubmit}
                disabled={submitting}
                color="green"
                inverted
            >
                <Icon name="checkmark" />
                <FormattedMessage
                    id="pages.seminars.DeleteSeminarDialog.yes"
                    defaultMessage="Yes"
                />
            </Button>
        </Modal.Actions>
    </Modal>
);

export default DeleteSeminarDialog;
